// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"7a943f65","362":"7a943f65","570":"2ef81caf","924":"7a943f65"}[chunkId] + ".chunk.css";
};